module.exports = __webpack_public_path__ + "img/css_3.015a91a2.svg";